import { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import type { OpenInvitation, TeamsApi } from 'api-client';

export default function PendingInvitations({ apiClient }: { apiClient: TeamsApi }) {
  const [invitations, setInvitations] = useState<OpenInvitation[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [retry, setRetry] = useState<number>(0);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    apiClient
      .userInvitations()
      .then((result) => {
        if (!cancelled) setInvitations(result.results);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [apiClient, retry]);
  return (
    <Stack component="section" aria-labelledby="pending-invitations-title" spacing={2}>
      <Typography id="pending-invitations-title" component="h2" variant="h5">
        Pending Invitations
      </Typography>
      {loading ? (
        <CircularProgress aria-label="Loading invitations" />
      ) : error ? (
        <Alert
          severity="error"
          action={
            <Button color="inherit" onClick={() => setRetry((value) => value + 1)}>
              Retry invitations
            </Button>
          }
        >
          Could not load invitations.
        </Alert>
      ) : invitations.length ? (
        invitations.map((invitation) => (
          <Paper key={invitation.id} sx={{ p: 2 }}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              alignItems={{ sm: 'center' }}
              justifyContent="space-between"
            >
              <Typography>{invitation.teamName}</Typography>
              <Button href={invitation.verified ? `/teams/accept/${invitation.id}` : '/accounts/email/'}>
                {invitation.verified ? 'View Invitation' : `Verify "${invitation.email}" to accept`}
              </Button>
            </Stack>
          </Paper>
        ))
      ) : (
        <Typography color="text.secondary">No pending invitations.</Typography>
      )}
    </Stack>
  );
}
